export default "__VITE_ASSET__CBumiVEM__"